{
  "tabs": {
    "overview": "Resumen general",
    "transfers": "Transferencias",
    "portfolio": "Cartera",
    "ledger": "Libro mayor",
    "trades": "Transacciones"
  },
  "state": {
    "FROZEN": "Congelado",
    "ACTIVE": "Activo",
    "INACTIVE": "Cerrado",
    "AWAITING_APPROVAL": "En espera de aprobación"
  },
  "highlights": {
    "tradingProcess": "Proceso de operación",
    "goalType": "Tipo de meta: {{goalType}}",
    "portfolio": "Cartera: {{portfolioType}}",
    "portfolioTheme": "Tema de cartera: {{portfolioTheme}}",
    "feeGrid": "Tabla de tarifas",
    "billingCycle": "Ciclo de facturación",
    "skipIPS": {
      "true": "IPS: No requerido",
      "false": "IPS: Requerido"
    },
    "allowDeposit": "Permitir depósitos",
    "suitabilityScore": "Puntuación de idoneidad: {{score}}",
    "allowFractionalShares": "Permitir acciones fraccionadas",
    "liquidated": "Subcuenta liquidada"
  },
  "createdAt": "Creado el {{date}}",
  "subAccountInformation": "Información de la subcuenta",
  "linkedGoal": "Meta vinculada",
  "account": "Cuenta",
  "portfolioInformation": "Información sobre la cartera",
  "portfolioTheme": "Tema de la cartera",
  "portfolio": "Cartera",
  "Fees": "Tarifas",
  "feeGrid": "Tabla de tarifas",
  "BilingCycle": "Ciclo de facturación",
  "frequency": {
    "BI_WEEKLY": "Quincenal",
    "DAILY": "Diario",
    "LAST_DAY_OF_THE_MONTH": "Último día del mes",
    "MONTHLY": "Mensual",
    "ONE_TIME": "Una vez",
    "SEMI_MONTHLY": "Dos veces al mes",
    "WEEKLY": "Semanal",
    "ANNUAL": "Anual",
    "QUARTERLY": "Trimestral",
    "SEMESTRAL": "Semestral"
  },
  "acceptablePortfolio": "Cartera aceptable",
  "notAcceptablePortfolio": "Cartera no aceptable",
  "notAcceptableFinancialProduct": "Este no es un producto financiero aceptable",
  "editSubAccount": "Editar subcuenta"
}
